import { cx } from "@linaria/core";
import type { FC } from "react";
import { memo } from "react";
import { cssIsActive } from "../../../styles/utils/Utils";
import { Shop } from "../Shop";
import { StyledShopList } from "../Shop/StyledShop";
import { ShopListPropsType } from "../types";
const ShopList: FC<ShopListPropsType> = memo(({
  onNameClick,
  activatedShop,
  shops,
  withRouteToDetail,
  selectedShopId,
  shopBody,
  onSelectShop,
  enableSelectShop = false,
  extendElements
}) => {
  return <StyledShopList role={"shoplist"}>
        {shops.map(s => <Shop key={s.uuid} shop={s} className={cx(s.uuid === activatedShop?.uuid && cssIsActive)} onNameClick={onNameClick} withRouteToDetail={withRouteToDetail} isSelected={!!selectedShopId ? s.uuid === selectedShopId : undefined} isActivated={!!activatedShop?.uuid ? s.uuid === activatedShop.uuid : undefined} onSelectHandle={onSelectShop} enableSelectShop={enableSelectShop}>
            {extendElements !== undefined && extendElements[s.uuid]?.element()}
            {shopBody}
          </Shop>)}
      </StyledShopList>;
});
ShopList.displayName = "ShopList";
export { ShopList };